import React from 'react';
import { PageContainer } from "@/components/layout/PageContainer";
import { BlogPostList } from "@/components/blog/BlogPostList";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import type { BlogPost } from "@/integrations/supabase/types/blog-types";

const BlogPage = () => {
  console.log('Blog page component rendering');

  const { data: posts, isLoading, refetch } = useQuery<BlogPost[]>({
    queryKey: ['blog-posts'],
    queryFn: async (): Promise<BlogPost[]> => {
      console.log('Fetching blog posts');
      // Mock blog posts data for marketing site
      const mockPosts: BlogPost[] = [
        {
          id: '1',
          title: 'The Future of Healthcare AI',
          author: 'Dr. Smith',
          content: 'Exploring how artificial intelligence is transforming healthcare delivery.',
          published_date: '2024-03-15',
          content_type: 'article' as const
        },
        {
          id: '2',
          title: 'Digital Health Trends 2024',
          author: 'Jane Doe',
          content: 'Key trends shaping the digital health landscape this year.',
          published_date: '2024-03-10',
          content_type: 'article' as const
        }
      ];

      return new Promise<BlogPost[]>((resolve) => {
        setTimeout(() => {
          resolve(mockPosts);
        }, 500);
      });
    },
    meta: {
      onError: (error) => {
        console.error('Error fetching blog posts:', error);
      }
    }
  });

  return (
    <PageContainer>
      <div className="max-w-6xl mx-auto p-6 space-y-8">
        <h1 className="text-3xl font-bold">Blog</h1>
        
        {isLoading ? (
          <div className="flex justify-center items-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
          </div>
        ) : (
          <BlogPostList 
            posts={posts || []} 
            onRefresh={refetch}
            readOnly
          />
        )}
      </div>
    </PageContainer>
  );
};

export default BlogPage;